import { render, staticRenderFns } from "./ScadenzarioAzi.vue?vue&type=template&id=6d5ddc36&scoped=true"
import script from "./ScadenzarioAzi.vue?vue&type=script&lang=js"
export * from "./ScadenzarioAzi.vue?vue&type=script&lang=js"
import style0 from "./ScadenzarioAzi.vue?vue&type=style&index=0&id=6d5ddc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ddc36",
  null
  
)

export default component.exports